
import VueSelect from "vue-select";
import DeleteIcon from "vue-material-design-icons/Delete";
import { SistemaMixin } from "@/modules/Application";
import { store as nfeStore } from "@/modules/NFe/storeNfe";

const DADOS_ENDPOINT = "/financeiro/cliente-creditos/devolucao-venda/dados";
const CONFIRMAR_ENDPOINT = "/financeiro/cliente-creditos/devolucao-venda";

export default {
  name: "DevolucaoVendaModal",
  mixins: [SistemaMixin],
  components: {
    DeleteIcon,
    VueSelect,
  },
  props: {
    venda: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      modalId: "modal-devolucao-venda",
      vendaCompleta: null,
      itens: [],
      cliente: null,
      clientes: [],
      gerarCredito: true,
      permiteCreditoVoucher: true,
      isLoading: false,
      isSaving: false,
      erro: null,
      clienteSearchTimer: null,
      fields: [
        { key: "descricao", label: "Produto" },
        { key: "quantidade", label: "Qtd. venda" },
        { key: "quantidade_devolver", label: "Qtd. devolução" },
        { key: "valor_total", label: "Valor" },
        { key: "actions", label: "" },
      ],
    };
  },
  computed: {
    nomeCliente() {
      return (
        (this.vendaCompleta && this.vendaCompleta.nomeCliente) ||
        (this.cliente && this.cliente.nome) ||
        this.venda.nomeCliente ||
        ""
      );
    },
    documentoVenda() {
      return (
        (this.vendaCompleta && this.vendaCompleta.numero) ||
        this.venda.numero ||
        "-"
      );
    },
    valorVenda() {
      return Number(
        (this.vendaCompleta && this.vendaCompleta.valorTotal) ||
          this.venda.valorTotal ||
          0
      );
    },
    clienteId() {
      return this.cliente && this.cliente.id_pessoa;
    },
    valorTotal() {
      return this.round2(
        this.itens.reduce((total, item) => total + this.getValorItem(item), 0)
      );
    },
    salvarBloqueado() {
      return (
        this.isLoading ||
        this.isSaving ||
        !!this.erro ||
        this.itensDisponiveis.length === 0 ||
        this.valorTotal <= 0 ||
        !!this.itemComQuantidadeInvalida ||
        (this.gerarCredito && !this.clienteId) ||
        (this.gerarCredito && !this.permiteCreditoVoucher)
      );
    },
    itensDisponiveis() {
      return this.itens.filter((item) => !item.devolvido);
    },
    itemComQuantidadeInvalida() {
      return this.itensDisponiveis.find((item) =>
        this.isQuantidadeDevolverInvalida(item)
      );
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$bvModal.show(this.modalId);
      this.carregarDados();
    });
  },
  methods: {
    onHidden() {
      this.$emit("hidden");
    },
    round2(valor) {
      return Math.round((Number(valor) || 0) * 100) / 100;
    },
    getVendaId() {
      return this.venda.id || this.venda.id_nfe || this.venda.nfe_id;
    },
    parseDadosVenda(payload) {
      let dados = payload && (payload.dados || payload.nfe || payload);

      if (typeof dados === "string") {
        dados = JSON.parse(dados || "{}");
      }

      if (dados && dados.dados) {
        dados =
          typeof dados.dados === "string"
            ? JSON.parse(dados.dados || "{}")
            : dados.dados;
      }

      return dados || {};
    },
    normalizarCliente(cliente) {
      if (!cliente || !cliente.id_pessoa) return null;

      return {
        ...cliente,
        nome: cliente.nome || cliente.name || cliente.label,
      };
    },
    async carregarDados() {
      const idNfeOrigem = this.getVendaId();

      if (!idNfeOrigem) {
        this.erro = "Venda selecionada sem identificador para devolução.";
        return;
      }

      this.isLoading = true;
      this.erro = null;

      try {
        const { data } = await this.$http.post(DADOS_ENDPOINT, {
          id_nfe_origem: idNfeOrigem,
        });
        const dados = this.parseDadosVenda(data);
        const produtos = Array.isArray(dados.productOfTradeCollection)
          ? dados.productOfTradeCollection
          : [];
        const cliente = this.normalizarCliente(dados.buyer);

        this.vendaCompleta = {
          ...this.venda,
          ...data,
          dados,
        };
        this.cliente = cliente;
        this.clientes = cliente ? [cliente] : [];
        this.permiteCreditoVoucher = data.permite_credito_voucher !== false;
        if (!this.permiteCreditoVoucher) {
          this.gerarCredito = false;
        }
        this.itens = produtos.map((item, index) =>
          this.formatarItem(item, index)
        );

        if (!this.itens.length) {
          this.erro = "Nenhum item encontrado para devolução.";
        }
      } catch (error) {
        this.erro =
          (error.response && error.response.data && error.response.data.msg) ||
          "Não foi possível carregar os itens da venda.";
      } finally {
        this.isLoading = false;
      }
    },
    formatarItem(item, index) {
      const produto = item.product || {};
      const quantidade = Number(item.quantity) || 1;
      const quantidadeDevolvida = Number(item.quantidade_devolvida) || 0;
      const quantidadeDisponivel =
        item.quantidade_disponivel_devolucao === null ||
        item.quantidade_disponivel_devolucao === undefined
          ? Math.max(quantidade - quantidadeDevolvida, 0)
          : Number(item.quantidade_disponivel_devolucao);
      const devolvido =
        item.devolvido ||
        quantidadeDisponivel <= 0 ||
        quantidadeDevolvida >= quantidade - 0.0001;
      const total =
        Number(
          item.totalPrice || item.valor_total || item.price * quantidade
        ) || 0;

      return {
        index,
        item_index: item.item_index ?? item.currentIndex ?? index,
        descricao: produto.descricao || item.descricao || "Produto",
        quantidade,
        quantidade_devolvida: quantidadeDevolvida,
        quantidade_disponivel: quantidadeDisponivel,
        quantidade_devolver: devolvido
          ? quantidadeDevolvida
          : quantidadeDisponivel,
        devolvido,
        valor_unitario:
          Number(item.price || item.valor_unitario || produto.preco) || 0,
        valor_liquido_unitario: quantidade > 0 ? total / quantidade : 0,
        valor_desconto: Number(item.discount || item.valor_desconto) || 0,
        original: item,
      };
    },
    isItemDevolvido(item) {
      return !!item.devolvido;
    },
    getQuantidadeDisponivel(item) {
      return Number(item.quantidade_disponivel) || 0;
    },
    isQuantidadeDevolverInvalida(item) {
      if (this.isItemDevolvido(item)) return false;

      const quantidade = Number(item.quantidade_devolver) || 0;
      return quantidade > this.getQuantidadeDisponivel(item) + 0.0001;
    },
    getQuantidadeState(item) {
      return this.isQuantidadeDevolverInvalida(item) ? false : null;
    },
    formatarQuantidade(valor) {
      const quantidade = Number(valor) || 0;

      return Number.isInteger(quantidade)
        ? quantidade.toString()
        : quantidade.toString().replace(".", ",");
    },
    validarQuantidadeDevolver(item) {
      if (!this.isQuantidadeDevolverInvalida(item)) return;

      this.$toast.error(
        `A quantidade devolvida não pode ser maior que ${this.formatarQuantidade(
          item.quantidade_disponivel
        )}.`
      );
    },
    getItemIndex(item) {
      return item.item_index ?? item.original?.item_index ?? item.index;
    },
    getValorItem(item) {
      if (this.isItemDevolvido(item)) return 0;

      const quantidade = Math.min(
        Number(item.quantidade_devolver) || 0,
        Number(item.quantidade_disponivel) || 0
      );
      return this.round2(
        (Number(item.valor_liquido_unitario) || 0) * quantidade
      );
    },
    removerItem(item) {
      this.itens = this.itens.filter(
        (devolucaoItem) => devolucaoItem.index !== item.index
      );
    },
    onSearchCliente(search, loading) {
      loading(true);
      if (this.clienteSearchTimer) clearTimeout(this.clienteSearchTimer);

      this.clienteSearchTimer = setTimeout(async () => {
        if (!search || search.length < 2) {
          this.clientes = [];
          loading(false);
          return;
        }

        this.clientes = await this.getClientes(search);
        loading(false);
      }, 350);
    },
    async salvar() {
      if (this.itemComQuantidadeInvalida) {
        this.validarQuantidadeDevolver(this.itemComQuantidadeInvalida);
        return;
      }

      if (this.salvarBloqueado) return;

      this.isSaving = true;

      try {
        const itens = this.itensDisponiveis
          .filter((item) => this.getValorItem(item) > 0)
          .map((item) => {
            const quantidade = Math.min(
              Number(item.quantidade_devolver) || 0,
              this.getQuantidadeDisponivel(item)
            );

            return {
              ...item.original,
              item_index: this.getItemIndex(item),
              quantidade,
              quantity: quantidade,
              quantidade_original: item.quantidade,
              valor_unitario: item.valor_unitario,
              valor_liquido_unitario: item.valor_liquido_unitario,
              valor_desconto: item.valor_desconto,
              valor_total: this.getValorItem(item),
            };
          });

        const { data } = await this.$http.post(CONFIRMAR_ENDPOINT, {
          id_pessoa: this.clienteId || null,
          id_nfe_origem: this.getVendaId(),
          gerar_credito: this.gerarCredito,
          tipo_reembolso: this.gerarCredito ? "credito_cliente" : "dinheiro",
          valor: this.valorTotal,
          itens,
          descricao: `Devolução de produto - Documento ${this.documentoVenda}`,
        });

        const voucherUrl = data["voucher-url"] || data.voucher_url;

        if (voucherUrl) {
          this.imprimir(voucherUrl);
        }

        this.$toast.success("Devolução registrada com sucesso.");
        this.$emit("registrada", data);
        this.$bvModal.hide(this.modalId);

        if (data.abrir_nfe_devolucao && data.nfe_devolucao) {
          this.abrirNFeDevolucao(data);
        }
      } catch (error) {
        this.$toast.error(
          (error.response && error.response.data && error.response.data.msg) ||
            "Erro ao registrar devolução."
        );
      } finally {
        this.isSaving = false;
      }
    },
    abrirNFeDevolucao(data) {
      nfeStore.devolucaoCreditoItens = data.itens_devolucao || [];
      nfeStore.refNFCe = data.nfe_devolucao.refNFCe || null;
      nfeStore.tpNF = 0;

      this.$router.push({
        name: "nfeNova",
        params: {
          nfeData: {
            ...data.nfe_devolucao,
            nfeId: null,
            cliente_credito_devolucao_itens: data.itens_devolucao || [],
          },
          fromDevolucao: true,
        },
      });
    },
    imprimir(url) {
      const printVoucher = window.open(url, "_blank");

      if (!printVoucher || printVoucher.closed) {
        this.$toast.error(
          "Habilite o popup do navegador para visualizar os relatórios/comprovantes"
        );
        return;
      }

      printVoucher.focus();

      setTimeout(() => {
        printVoucher.print();
      }, 1000);
    },
  },
};
